import React, { useState, createContext, useContext, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const GlobalContext = createContext(null);

export function GlobalProvider({children}) {
  const [userName, setUserName] = useState('');
  const [passWord, setPassWord] = useState('');
  const [tgRoute, setTgRoute] = useState('order');
  const [rMode, setRMode] = useState(false);
  const [rLogin, setRLogin] = useState(false);
  const [cusip, setCusip] = useState("");
  const [side, setSide] = useState("");
  const [quantity, setQuantity] = useState("");



  // const [reactAppApiUrl, setReactAppApiUrl] = useState(process.env.REACT_APP_API_URL);

  const updateUserName = useCallback((newUserName) => {
    setUserName(newUserName);
  }, []);

  const updatePassWord = useCallback((newPassWord) => {
    setPassWord(newPassWord);
  }, []);

  const updateTgRoute = useCallback((newTgRoute) => {
    setTgRoute(newTgRoute);
  }, []);

  const updateRMode = useCallback((newRMode) => {
    setRMode(newRMode === "true");
  }, []);

  const updateRLogin = useCallback((newRLogin) => {
    setRLogin(newRLogin === "true");
  }, []);  

  const updateCusip = useCallback((newCusip) => {
    setCusip(newCusip);
  }, []);  

  const updateSide = useCallback((newSide) => {
    setSide(newSide);
  }, []);  

  const updateQuantity = useCallback((newQuantity) => {
    setQuantity(newQuantity);
  }, []);  

  // const updateReactAppApiUrl = useCallback((newReactAppApiUrl) => {
  //   setReactAppApiUrl(newReactAppApiUrl);
  // }, []);


  const [searchParams] = useSearchParams();

  const uName = searchParams.get('userName');
  const pWord = searchParams.get('passWord');
  const tRoute = searchParams.get('targetRoute');
  const remoteMode = searchParams.get('remoteMode');
  const remoteLogin = searchParams.get('remoteLogin');
  const cusipSeed = searchParams.get('cusip');
  const sideSeed = searchParams.get('side');
  const quantitySeed = searchParams.get('quantity');

  //  const dataUrl = searchParams.get('dataUrl');

  useEffect(() => {

    if(uName) {
      updateUserName(uName);
    }
    if(pWord) {
      updatePassWord(pWord);
    }
    
    if(remoteMode) {
      updateRMode(remoteMode);
    }

    if(tRoute) {
        updateTgRoute(tRoute);
    }
    
    if(remoteLogin) {
        updateRLogin(remoteLogin);
    }

    if(cusipSeed) {
        updateCusip(cusipSeed);
    }    
    
    if(sideSeed) {
        updateSide(sideSeed);
    }    

    if(quantitySeed) {
        updateQuantity(quantitySeed);
    } 


    // if(dataUrl) {
    //   updateReactAppApiUrl(dataUrl);
    // }

  }, [
      uName, updateUserName,
      pWord, updatePassWord, 
      remoteMode, updateRMode, 
      tRoute, updateTgRoute, 
      remoteLogin, updateRLogin, 
      cusipSeed, updateCusip,
      sideSeed, updateSide,
      quantitySeed, updateQuantity
    ]);


  const contextValue = {
    userName,
    passWord,
    tgRoute,
    rMode,
    rLogin,
    cusip,
    side,
    quantity,
    // reactAppApiUrl,
    updateUserName,
    updatePassWord,
    updateTgRoute,
    updateRMode,
    updateRLogin,
    updateCusip,
    updateSide,
    updateQuantity
    // updateReactAppApiUrl
  };

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
}

export function useGlobalState() {
  const context = useContext(GlobalContext);
  if (!context) {
    // This error indicates that the hook is used outside of a GlobalProvider
    throw new Error('useGlobalState must be used within a GlobalProvider');
  }
  return context;
}

